const defaultProps = {
  CATEGORY: 'Kategorie wurde nicht gesetzt',
  DATE: 'Datum wurde nicht gesetzt',
  DESCRIPTION: 'Beschreibung wurde nicht gesetzt',
  DESCRIPTION_RICH: '<p>Beschreibung wurde nicht gesetzt</p>',
  TEXT: 'Text wurde nicht gesetzt',
  TITLE: 'Titel wurde nicht gesetzt',
  HEADLINE: 'Headline wurde nicht gesetzt',
  HEADLINE_WITH_PLACEHOLDER: 'Headline wurde nicht gesetzt',
  SUBTITLE: 'Subtitel wurde nicht gesetzt',
  IMAGE_ALT: 'Bildbeschreibung wurde nicht gesetzt',
  ARIA_LABEL: 'aria-label wurde nicht gesetzt',
  PLACEHOLDER: 'Placeholder wurde nicht gesetzt',
  FORMAT: 'Format wurde nicht gesetzt',
  SIZE: 'Größe wurde nicht gesetzt',
  NAME: 'Name wurde nicht gesetzt',
  ICON: 'construction-cone',
  URL: '#',
  CAPTION: 'Bild-Caption wurde nicht gesetzt',
}

export default defaultProps
